import { Injectable } from "@angular/core";


 @Injectable()

export class customFieldsProvider {

    public customFields;

    constructor(){
        this.customFields = {
            "version": "1.1.1.1",
            // this is basic structure that is going the data. If order does not has the custom field in db from adpcustomer table

             params : [
             {"paramId": 1,"label": "Transaction ID","value": "856", "type" : "Hard coded"},
             {"paramId": 2,"label": "Accounting Id","value": "CDWC", "type" : "Hard coded"},
             {"paramId": 3,"label": "Purpose","value": "", "type" : "Empty"},
             {"paramId": 4,"label": "Shipment ID","value": "CDW-2019-200", "type" : "Hard coded"},
             {"paramId": 5,"label": "Warehouse Name","value": "CDWC ", "type" : "Hard coded"},
             {"paramId": 6,"label": "Warehouse Code","value": "CDWC", "type" : "Hard coded"},
             {"paramId": 7,"label": "Manufacturer Name","value": "", "type" : "Empty"},
             {"paramId": 8,"label": "Manufacturer Code","value": "", "type" : "Empty"},
             {"paramId": 9,"label": "Ship to Name","value": "objCart.customer.name", "type" : "linked"},
             {"paramId": 10,"label": "Ship to Code","value": "", "type" : "Empty"},
             {"paramId": 11,"label": "Sold to Name","value": "", "type" : "Empty"},
             {"paramId": 12,"label": "Sold to Code","value": "", "type" : "Empty"},
             {"paramId": 13,"label": "Ship From Name","value": "objADPCust.adpCustomerInfo.companyName", "type" : "linked"},
             {"paramId": 14,"label": "Ship From Code","value": "CDWC", "type" : "Hard coded"},
             {"paramId": 15,"label": "Ship Date","value": "(objCart.expectedShipmentDate).split('-')[0] + (objCart.expectedShipmentDate).split('-')[1] + (objCart.expectedShipmentDate).split('-')[2]", "type" : "linked"},
             {"paramId": 16,"label": "Time (HH:MM)","value": "", "type" : "Empty"},
             {"paramId": 17,"label": "SCAC","value": "SCAC", "type" : "Hard coded"},
             {"paramId": 18,"label": "Transportation Method","value": "", "type" : "Empty"},
             {"paramId": 19,"label": "Routing","value": "TRUCKING", "type" : "Hard coded"},
             {"paramId": 20,"label": "Bill of Lading #","value": "", "type" : "Empty"},
             {"paramId": 21,"label": "Trailer #","value": "", "type" : "Empty"},
             {"paramId": 22,"label": "# of Total Shipped Rolls","value": "objCart.items.length", "type" : "linked"}, //
             {"paramId": 23,"label": "# of Total Packages","value": "", "type" : "Empty"},
             {"paramId": 24,"label": "Gross Weight","value": "TotalBeforeTax", "type" : "linked"},  //
             {"paramId": 25,"label": "Gross Weight UOM","value": "LBS", "type" : "Hard coded"},
             {"paramId": 26,"label": "Total Shipped Tare Weight","value": "", "type" : "Empty"},
             {"paramId": 27,"label": "Total Shipped Tare Weight UOM","value": "", "type" : "Empty"},
             {"paramId": 28,"label": "Net Weight","value": "", "type" : "Empty"},
             {"paramId": 29,"label": "Net Weight UOM","value": "", "type" : "Empty"},
             {"paramId": 30,"label": "Order Gross Weight","value": "", "type" : "Empty"},
             {"paramId": 31,"label": "Order Gross Weight UOM","value": "LBS", "type" : "Hard coded"},
             {"paramId": 32,"label": "Tare Weight","value": "", "type" : "Empty"},
             {"paramId": 33,"label": "Tare Weight UOM","value": "", "type" : "Empty"},
             {"paramId": 34,"label": "Order Net Weight","value": "", "type" : "Empty"},
             {"paramId": 35,"label": "Order Net Weight UOM","value": "", "type" : "Empty"},
             {"paramId": 36,"label": "Mill Order #","value": "CDWC", "type" : "Hard coded"},
             {"paramId": 37,"label": "Grade Code","value": "", "type" : "Empty"}, ////
             {"paramId": 38,"label": "Grade Name","value": "(item.name).split('|')[0]", "type" : "linked"}, ////
             {"paramId": 39,"label": "Color","value": "", "type" : "Empty"},
             {"paramId": 40,"label": "# of Rolls in Package","value": "", "type" : "Empty"},  ////
             {"paramId": 41,"label": "Width","value": "(item.name).split('|')[3].split(':')[0]", "type" : "linked"},
             {"paramId": 42,"label": "Width UOM","value": "Inch", "type" : "Hard coded"},
             {"paramId": 43,"label": "Packaging Code","value": "", "type" : "Empty"},
             {"paramId": 44,"label": "Diameter","value": "", "type" : "Empty"},
             {"paramId": 45,"label": "Diameter UOM","value": "", "type" : "Empty"},
             {"paramId": 46,"label": "Base Weight Size","value": "", "type" : "Empty"},
             {"paramId": 47,"label": "Base Weight","value": "", "type" : "Empty"},
             {"paramId": 48,"label": "Base Weight UOM","value": "", "type" : "Empty"},
             {"paramId": 49,"label": "# of Rolls","value": "", "type" : "Empty"},
             {"paramId": 50,"label": "# of Packages","value": "", "type" : "Empty"},
             {"paramId": 51,"label": "Gross Weight","value": "", "type" : "Empty"},
             {"paramId": 52,"label": "Gross Weight UOM","value": "", "type" : "Empty"},
             {"paramId": 53,"label": "Tare Weight","value": "", "type" : "Empty"},
             {"paramId": 54,"label": "Tare Weight UOM","value": "", "type" : "Empty"},
             {"paramId": 55,"label": "Net Weight","value": "", "type" : "Empty"},
             {"paramId": 56,"label": "Net Weight UOM","value": "", "type" : "Empty"},
             {"paramId": 57,"label": "Line #","value": "index", "type" : "linked"},  // row #
             {"paramId": 58,"label": "Roll #","value": "item.barCode", "type" : "linked"}, //
             {"paramId": 59,"label": "Item Gross Weight","value": "item.quantity", "type" : "linked"},//
             {"paramId": 60,"label": "Item Gross Weight UOM","value": "LBS", "type" : "Hard coded"},
             {"paramId": 61,"label": "Item Tare Weight","value": "", "type" : "Empty"},
             {"paramId": 62,"label": "Item Tare Weight UOM","value": "", "type" : "Empty"},
             {"paramId": 63,"label": "Item Net Weight","value": "", "type" : "Empty"},
             {"paramId": 64,"label": "Item Net Weight UOM","value": "", "type" : "Empty"},
             {"paramId": 65,"label": "Carrier #","value": "", "type" : "Empty"},
             {"paramId": 66,"label": "PO#","value": "", "type" : "Empty"},
             {"paramId": 67,"label": "Serial #","value": "", "type" : "Empty"},
             {"paramId": 68,"label": "Items Description","value": "", "type" : "Empty"},
             {"paramId": 69,"label": "Freight Fee Terms","value": "Prepaid [] 3rd-Party [] Collect []", "type" : "Hard coded"},
             {"paramId": 70,"label": "Line items","value": "objCart.items.length", "type" : "linked"},
             {"paramId": 71,"label": "Total","value": "TotalBeforeTax", "type" : "linked"},
             {"paramId": 72,"label": "Total Length","value": "totalLength", "type" : "linked"},
             {"paramId": 73,"label": "Sold to Company","value": "", "type" : "Empty"},
             {"paramId": 74,"label": "Sold to Address","value": "", "type" : "Empty"},
             {"paramId": 75,"label": "Ship Date","value": "objCart.expectedShipmentDate", "type" : "linked"},
             ],

             //section is telling the grouping of the fields inside the custom fields form

            // sections: [
            //   {
            //     "name" : "customFieldsForm", "lable" : "PICK Pack Form", sectionParams :[{"paramId" : "1", "sequence" : 1}]
            //   },
            //   {
            //     "name" : "commonFields", "lable" : "Common Param", sectionParams :[{"paramId" : "1", "sequence" : 4}]
            //   }
            // ],
            documents : [
                {"name" : "ASNCSV", "lable" : "ASN CSV", documentParams :[
                {"paramId" : "1", "sequence" : 1},
                {"paramId" : "2", "sequence" : 2},
                {"paramId" : "3", "sequence" : 3},
                {"paramId" : "4", "sequence" : 4},
                {"paramId" : "5", "sequence" : 5},
                {"paramId" : "6", "sequence" : 6},
                {"paramId" : "7", "sequence" : 7},
                {"paramId" : "8", "sequence" : 8},
                {"paramId" : "9", "sequence" : 9},
                {"paramId" : "10", "sequence" : 10},
                {"paramId" : "11", "sequence" : 11},
                {"paramId" : "12", "sequence" : 12},
                {"paramId" : "13", "sequence" : 13},
                {"paramId" : "14", "sequence" : 14},
                {"paramId" : "15", "sequence" : 15},
                {"paramId" : "16", "sequence" : 16},
                {"paramId" : "17", "sequence" : 17},
                {"paramId" : "18", "sequence" : 18},
                {"paramId" : "19", "sequence" : 19},
                {"paramId" : "20", "sequence" : 20},
                {"paramId" : "21", "sequence" : 21},
                {"paramId" : "22", "sequence" : 22},
                {"paramId" : "23", "sequence" : 23},
                {"paramId" : "24", "sequence" : 24},
                {"paramId" : "25", "sequence" : 25},
                {"paramId" : "26", "sequence" : 26},
                {"paramId" : "27", "sequence" : 27},
                {"paramId" : "28", "sequence" : 28},
                {"paramId" : "29", "sequence" : 29},
                {"paramId" : "30", "sequence" : 30},
                {"paramId" : "31", "sequence" : 31},
                {"paramId" : "32", "sequence" : 32},
                {"paramId" : "33", "sequence" : 33},
                {"paramId" : "34", "sequence" : 34},
                {"paramId" : "35", "sequence" : 35},
                {"paramId" : "36", "sequence" : 36},
                {"paramId" : "37", "sequence" : 37},
                {"paramId" : "38", "sequence" : 38},
                {"paramId" : "39", "sequence" : 39},
                {"paramId" : "40", "sequence" : 40},
                {"paramId" : "41", "sequence" : 41},
                {"paramId" : "42", "sequence" : 42},
                {"paramId" : "43", "sequence" : 43},
                {"paramId" : "44", "sequence" : 44},
                {"paramId" : "45", "sequence" : 45},
                {"paramId" : "46", "sequence" : 46},
                {"paramId" : "47", "sequence" : 47},
                {"paramId" : "48", "sequence" : 48},
                {"paramId" : "49", "sequence" : 49},
                {"paramId" : "50", "sequence" : 50},
                {"paramId" : "51", "sequence" : 51},
                {"paramId" : "52", "sequence" : 52},
                {"paramId" : "53", "sequence" : 53},
                {"paramId" : "54", "sequence" : 54},
                {"paramId" : "55", "sequence" : 55},
                {"paramId" : "56", "sequence" : 56},
                {"paramId" : "57", "sequence" : 57},
                {"paramId" : "58", "sequence" : 58},
                {"paramId" : "59", "sequence" : 59},
                {"paramId" : "60", "sequence" : 60},
                {"paramId" : "61", "sequence" : 61},
                {"paramId" : "62", "sequence" : 62},
                {"paramId" : "63", "sequence" : 63},
                {"paramId" : "64", "sequence" : 64},
                {"paramId" : "66", "sequence" : 65},
                ],
                },
                  {
                    "name" : "BOLForm", "lable" : "BOL Form", documentParams :[
                    {"sectionLabel" : "BOLHeader", "sequence" : 3, fields : [
                      {"paramId" : "20", "sequence" : 1},
                      {"paramId" : "75", "sequence" : 2},
                      {"paramId" : "65", "sequence" : 3},
                      {"paramId" : "66", "sequence" : 4},
                      {"paramId" : "17", "sequence" : 5},
                      {"paramId" : "67", "sequence" : 6},
                      {"paramId" : "70", "sequence" : 7},
                      {"paramId" : "71", "sequence" : 8},
                      {"paramId" : "68", "sequence" : 9},
                      {"paramId" : "21", "sequence" : 10},
                      {"paramId" : "69", "sequence" : 11},
                    ],
                 },
                ]
                  },

                  {
                    "name" : "ASNForm", "lable" : "ASN Form", documentParams :[
                    {"paramId" : "1", "sequence" : 3}]
                  },

                  {
                    "name" : "customFields", "lable" : "Custom Fields", documentParams :[
                      {"sectionLabel" : "none", "sequence" : 1, fields : [
                        {"paramId" : "21", "sequence" : 1},
                        {"paramId" : "23", "sequence" : 2},
                        {"paramId" : "30", "sequence" : 3},
                        {"paramId" : "37", "sequence" : 4},
                        {"paramId" : "19", "sequence" : 5},
                        {"paramId" : "20", "sequence" : 6},
                        {"paramId" : "65", "sequence" : 7},
                        {"paramId" : "66", "sequence" : 8},
                        {"paramId" : "67", "sequence" : 9},
                        {"paramId" : "68", "sequence" : 10},
                        {"paramId" : "73", "sequence" : 11},
                        {"paramId" : "74", "sequence" : 12},
                        {"paramId" : "2", "sequence" : 13},
                      ],
                      },
                    ]
                  },

              {
                "name" : "pickPackShip", "lable" : "Pick Pack Ship", documentParams :[
                  {"sectionLabel" : "none", "sequence" : 1, fields : [
                      {"paramId" : "72", "sequence" : 1}
                    ],
                  },
                ]
              },

             ]

            }


    }


  }



// WEBPACK FOOTER //
// ./src/providers/params.ts